<div class="row config controls-panel">
  <div class="title">
    <h3>World <i [style]="{opacity: loading ? 1 : 0}" class="fas fa-sync fa-spin text-muted title-spinner"></i></h3>
  </div>
  <div class="col-md-6 text-right"></div>
</div>
<div #chartContainer>
  <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="chartOptions"
    (chartInstance)="setChart($event)"></highcharts-chart>
</div>
